export default "__VITE_ASSET__ffeQ9ZEX__"